module.exports = __webpack_public_path__ + "img/apple-imac-retina.3ac4c22c.png";